import { Cookies } from 'react-cookie';

import { TotalEatenBaitLineChartData } from '../types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getTotalEatenBaitLineChart = async (
  slug: string,
  period: string,
  step: string,
  start_date: string,
  end_date: string,
) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`/analitycs/yearly-bait-eaten-sum/${slug}/${period}/${step}/`, {
    headers: {
      Authorization: token,
    },
    params: {
      start_date,
      end_date,
    },
  });
  return data.data as TotalEatenBaitLineChartData[];
};
